import { Box } from '@mui/material';
import Image from 'next/image';

import AppStores from 'components/@common/AppStores';

interface Props {
  onClick?: () => void;
}

const AppStoresWithQR = ({ onClick }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: { xs: 'center', md: 'flex-start' },
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: 96,
          height: 96,
        }}
      >
        <Image
          src="/images/app-qr.svg"
          width={96}
          height={96}
          alt="App QR Code"
          unoptimized
        />
      </Box>
      <AppStores
        sx={{ flexDirection: { xs: 'row', md: 'column' } }}
        onClick={onClick}
      />
    </Box>
  );
};

export default AppStoresWithQR;
